import { Component } from '@angular/core';
import { HttpService } from '../https.service';
import { URLUtils } from '../urlUtils';
import { AddLeadModalComponent } from '../modal/add-lead-modal/add-lead-modal.component';
import { UploadFileModalComponent } from '../modal/upload-file-modal/upload-file-modal.component';
import { Lead } from '../modal/lead.model';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationComponent, ConfirmationType } from '../modal/confirmation/confirmation.component';
import { LeadDetailsModalComponent } from '../modal/lead-details-modal/lead-details-modal.component';
import { UpdateStatusModalComponent } from '../modal/update-status-modal/update-status-modal.component';
import { NgxSpinnerService } from "ngx-spinner";
import { AddNotesModalComponent } from '../modal/add-notes-modal/add-notes-modal.component';
import { LeadsService } from '../service/lead.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/internal/operators/filter';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';  
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from '../modal/confirmation-dialog/confirmation-dialog.component';
import { SuccessDocMessageComponent } from '../modal/success-message/success-message.component';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
    selector: 'app-queries-list',
    templateUrl: './queries-list.component.html',
    styleUrls: ['./queries-list.component.css'],
    standalone: false
})
export class QueriesListComponent {
  queries:any[]=[];
  filteredQueries: any[] = [];
  searchTerm: string = '';
  searchTermChanged = new Subject<string>();
  currentPage: number = 1;
  itemsPerPage: number = 10;
  departmentsMap: { [key: string]: string } = {};
  queryId: any;
  uid:any;
  leadNotes: Map<string, string> = new Map();
  sortKey: string = '';
  isReverse: boolean = false;
  selectedMatter: string = "inquiry";
  
  lastLeadId: any = null;  // Track the last item's ID
  totalLeads: number = 0;

  constructor(private modalService: NgbModal,    private spinner: NgxSpinnerService, private http: HttpClient, private router: Router, private httpService: HttpService, private leadsService: LeadsService,  private route: ActivatedRoute, private toastr: ToastrService) { }
  
  convertUTCStringToLocal(dateString: string): string {
  // console.log('Original UTC Date String:', dateString);

  // Split and parse
  const parts = dateString.split(' - ');
  if (parts.length !== 2) return dateString;

  const [datePart, timePart] = parts;
  const fullDateString = `${datePart} ${timePart} UTC`;

  const date = new Date(fullDateString);
  // console.log('Parsed Date Object:', date);

  if (isNaN(date.getTime())) return dateString;

  // Format parts
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 => 12
  const hourStr = String(hours).padStart(2, '0');

  const formatted = `${day} ${month} ${year} - ${hourStr}:${minutes} ${ampm}`;
  // console.log('Converted to Local Format:', formatted);
  return formatted;
}


  ngOnInit() {
    // Get Queries
    this.httpService.sendGetRequest(URLUtils.getQueryList()).subscribe((res: any) => {
      this.queries = res.data.reverse().map((query: any) => {
      return {
        ...query,
        created: this.convertUTCStringToLocal(query.created)
      };
    });

    // console.log('Queries with local time:', this.queries);
      this.filteredQueries = this.queries;
      this.mapDepartmentNames(); // Call after deptMap is ready
      // console.log('queries',this.queries);
    });
  
    // Get Departments
    this.uid = localStorage.getItem('profuid');
    this.httpService.sendReGetRequest(URLUtils.getDepartment(this.uid)).subscribe((res: any) => {
      const departments = res.data || [];
      departments.forEach((dept: any) => {
        this.departmentsMap[dept.id] = dept.name;
      });
  
      this.mapDepartmentNames(); // Call after queries are ready
    });  

    this.searchTermChanged.pipe(
      debounceTime(300),      // wait 300ms after the last keystroke
      distinctUntilChanged()  // only if the text is different
    ).subscribe(term => {
      this.currentPage = 1;  // RESET to first page
      if (term.trim()) {
        this.getQuerySearch(term);
      } else {
        // Optionally fetch all leads again or clear the list
        this.getQueryList();  // assuming you have a method to get all
      }
    });

    if (window.location.pathname == '/queries') {
      this.selectedMatter='inquiry';
    }
  }
  
  
  mapDepartmentNames() {
    if (!this.queries?.length || !Object.keys(this.departmentsMap).length) return;
    this.queries.forEach((query: any) => {
      if (Array.isArray(query.department)) {
        query.department = query.department
          .map((id: string) => this.departmentsMap[id])
          .filter(Boolean) // skip undefined
          .join('\n');
      } else {
        query.department = '';
      }
    });
  }

  getQueryList(){
    this.httpService.sendGetRequest(URLUtils.getQueryList()).subscribe((res: any) => {
      this.queries = res.data;
      this.filteredQueries = this.queries;
      this.mapDepartmentNames(); // Call after deptMap is ready
      console.log('queries',this.queries);
    });
  }  

  fetchLeadsLimit() {
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.getQueryLimit(this.itemsPerPage))
      .subscribe((response: any) => {
        this.spinner.hide();
        this.queries = response.data;
        this.filteredQueries = response.data;
        
        // Track last item's ID for next page request
        if (response.data.length > 0) {
          this.lastLeadId = response.data[response.data.length - 1].id;
        }
  
        // Optionally store total count if available
        if (response.total) {
          this.totalLeads = response.total;
        }
      });
  }

  fetchNextLeads() {
    //console.log('lastLeadId',this.lastLeadId)
    //if (!this.lastLeadId) return;  // No more leads to fetch
  
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.getNCQueryLimit(this.itemsPerPage, this.lastLeadId))
      .subscribe((response: any) => {
        this.spinner.hide();
        const newLeads = response.data;
  
        if (newLeads.length > 0) {
          // Append to current list
          this.queries = [...this.queries, ...newLeads];
          this.filteredQueries = [...this.filteredQueries, ...newLeads];
          // Update last lead ID
          this.lastLeadId = newLeads[newLeads.length - 1].id;
        } else {
          // No more leads to fetch
          console.log('No more leads');
        }
      });
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.fetchNextLeads();      
      // console.log('currentPage',this.currentPage)
      // console.log('itemsPerPage',this.itemsPerPage)
      // console.log('this.leads.length',this.leads.length)

      // const totalLoadedPages = Math.ceil(this.leads.length / this.itemsPerPage);
      // console.log('ccc',totalLoadedPages)
      // Check: if the new page needs data that isn't loaded yet
      // if (page > totalLoadedPages) {
      //   console.log(`Need to load page ${page}, current loaded pages: ${totalLoadedPages}`);
      //   this.fetchNextLeads();
      // } else {
      //   console.log(`Page ${page} is already loaded`);
      // }
    }
  }

  search() {
    if (!this.searchTerm.trim()) {
      this.filteredQueries = this.queries;
      return;
    }
    
    const term = this.searchTerm.toLowerCase();
    this.filteredQueries = this.queries.filter(query => 
      query.name.toLowerCase().includes(term) || 
      query.email.toLowerCase().includes(term) ||
      query.department.toLowerCase().includes(term)
    );
  }
  
  generateLink(q:any){
    //pass id
    setTimeout(() => {
      this.openConfirmationDialog(q);
    }, 100); 
  }  

  openConfirmationDialog(q:any): void {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.confirmationType = ConfirmationType.ATTACH_GENLINK;

    let payload = {
      id: q.id       
    }
    this.uid = localStorage.getItem('profuid');
    modalRef.result.then(
      (result) => {
        if (result === 'genlink') {
          this.httpService.sendRePostRequest(URLUtils.genLink(this.uid,q.id), payload).subscribe({
            next: (res: any) => {
              this.showSuccessModal(q);
            },
            error: (err) => {
              // Show toast message on error
              this.toastr.error('Failed to generate link! Please try again.');
              console.error('Request failed:', err);
            }
          });
        }
      },
      (reason) => {
        // Confirmation dialog dismissed
      }
    );
  }

  showSuccessModal(q:any) {
    let name = q.name;
    const successModalRef = this.modalService.open(SuccessDocMessageComponent);
    successModalRef.componentInstance.message = `Document sharing link with ${name} shared successfully`;
  }

  confirmDelete(id: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
  
    // Pass the ID to the modal component
    modalRef.componentInstance.queryId = id;
    // Set the confirmation type to DELETE_QUERY
    modalRef.componentInstance.confirmationType = ConfirmationType.DELETE_QUERY;
    //
    modalRef.result.then((result) => {
      if (result === 'deleted') {
        this.getQueryList(); 
        // Refresh queries list after deletion
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  deleteQuery(id:any) {
    this.uid = localStorage.getItem('profuid');
    this.httpService.sendDeleteRequest(URLUtils.deleteQuery(id, this.uid)).subscribe((response: any) => {
      this.getQueryList();
    });
  }

  viewLeadDetails(query: any)  {
    //console.log('pass query', query)
    this.router.navigate(['/queries', query.id]);
    this.leadsService.setLead(query);
  }

  viewDownloadDetails(query: any)  {
    this.router.navigate(['/download-details', query.id]);
    this.leadsService.setLead(query);
  }

  viewDocuments(lead: any)  {
    const c = `/viewdoc/${lead.id}`
    this.router.navigate([`/viewdoc/${lead.id}`]);
  }
  
  openUpdateStatusModal(lead: any): void {
    // Implementation for opening update status modal
    //console.log('Open update status modal for lead', lead);
    const modalRef = this.modalService.open(UpdateStatusModalComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    });
    
    // Pass lead data to modal
    modalRef.componentInstance.lead = { ...lead };
    modalRef.componentInstance.isQuery = true;
    
    modalRef.result.then((result) => {
      this.httpService.sendGetRequest(URLUtils.getQueryList()).subscribe((res: any) => {
        this.queries = res.data.reverse();
        this.filteredQueries = this.queries;
        this.mapDepartmentNames();
      });

     // if (result) {
      //  this.getQueryList();
        // If lead was updated, refresh the list
        // this.leadsService.getLeadlist().subscribe((leads:any) => {
        //   this.leads = leads;
        //   this.search(); // Apply current search filter
        // });
     // }
    }, (reason) => {
      // Modal dismissed
    });
  }

  // In queries-list.component.ts
addNotesModal(query: any) {
  const modalRef = this.modalService.open(AddNotesModalComponent, {
    centered: true,
    size: 'md',
    backdrop: 'static',    // disables closing on outside click
    keyboard: false,  
  });
  
  // Pass the query data and explicitly set isQuery to true
  modalRef.componentInstance.lead = { ...query };
  modalRef.componentInstance.isQuery = true;
  modalRef.componentInstance.queryId = query.id;
  
  //console.log('Opening notes modal for query:', query.id); // Debug log
  
  modalRef.result.then((result) => {
    if (result) {
      //this.getQueryList(); // Refresh the query list
        console.log('Update status modal closed with result:', result);
        this.httpService.sendGetRequest(URLUtils.getQueryList()).subscribe((res: any) => {
          this.queries = res.data.reverse();
          this.filteredQueries = this.queries;
          this.mapDepartmentNames();
        });
      if (result.notes) {
        this.leadNotes.set(query.id, result.notes);
        
        const updatedQuery = this.queries.find(q => q.id === query.id);
        if (updatedQuery) {
          updatedQuery.hasNotes = true;
        }
      }
    }
  }, (reason) => {
    // Modal dismissed
  });
}
  getPaginatedqueries() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredQueries.slice(startIndex, endIndex);
  }
  
  getTotalPages() {
    return Math.ceil(this.filteredQueries.length / this.itemsPerPage);
  }
  getPageNumbers(): number[] {
    const totalLoadedPages = Math.ceil(this.filteredQueries.length / this.itemsPerPage);
    return Array.from({ length: totalLoadedPages }, (_, i) => i + 1);
  }

  // getTotalPages() {
  //   return Math.ceil(this.filteredQueries.length / this.itemsPerPage);
  // }
  
  // getPageNumbers() {
  //   const totalPages = this.getTotalPages();
  //   return Array.from({ length: totalPages }, (_, i) => i + 1);
  // }
  
  // changePage(page: number) {
  //   if (page >= 1 && page <= this.getTotalPages()) {
  //     this.currentPage = page;
  //   }
  // }
  
  getPaginationRange() {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(start + this.itemsPerPage - 1, this.filteredQueries.length);
    return `${start}-${end} of ${this.filteredQueries.length} items`;
  }
  sortQueries(key: string) {
    this.isReverse = this.sortKey === key ? !this.isReverse : false;
    this.sortKey = key;
  
    this.filteredQueries = [...this.filteredQueries].sort((a: any, b: any) => {
      const valA = (a[key] || '').toString().toLowerCase();
      const valB = (b[key] || '').toString().toLowerCase();
  
      if (valA < valB) return this.isReverse ? 1 : -1;
      if (valA > valB) return this.isReverse ? -1 : 1;
      return 0;
    });
  }
  
  onClick(value: string) {
    this.selectedMatter = value;
    //this.selectedMatter=='legalmatter'?this.router.navigate(['/matter/legalmatter/'+this.selectedValue]):this.router.navigate(['/matter/generalmatter/'+this.selectedValue]);
  }

  onSearchChange() {
    this.searchTermChanged.next(this.searchTerm);
  }

  getQuerySearch(a:any) {
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.searchQuery(a)).subscribe((response: any) => {
      this.spinner.hide();
      this.queries = response.data;
      this.filteredQueries = this.queries;
    });
  }
}
